<div class="table-container mt-3">
  <div class="table-scroll-wrap">
    <table class="session-table">
      <colgroup>
        <col style="width: 15%" />
        <col style="width: 20%" />
        <col style="width: 15%" />
        <col style="width: 15%" />
        <col style="width: 15%" />
        <col style="width: 10%" />
        <col style="width: 10%" />
      </colgroup>
      <thead class="table-headings">
        <tr>
          <th>Device ID</th>
          <th>Device</th>
          <th>Device Type</th>
          <th>Location</th>
          <th>IP address</th>
          <th>Last active</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        @if (paginatedSessions.length === 0) {
          <tr>
            <td colspan="100%" class="no-data-cell">No active sessions found</td>
          </tr>
        } @else {
          @for (session of paginatedSessions; track $index) {
            <tr>
              <td>{{ session.deviceId }}</td>
              <td>
                <span class="fw-medium">{{ session.device }}</span>
                @if (session.current) {
                  <span class="badge-current">Current</span>
                }
              </td>
              <td>{{ session.deviceType }}</td>
              <td>{{ session.location }}</td>
              <td class="ip-cell">
                {{ session.ip }}
              </td>
              <td>{{ session.lastActive | date: "MM-dd-yyyy" }}</td>
              <td class="text-center">
                @if (!session.current) {
                  <button class="revoke-btn" (click)="confirmRevoke(session)">
                    Revoke
                  </button>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <div class="table-footer">
    <div class="entries-info">
      Showing {{ startIndex }} to {{ endIndex }} of {{ totalEntries }} Entries
    </div>
    <div class="pagination-controls">
      <span class="page-size-label">Page Size:</span>
      <select
        class="page-size-select"
        [value]="pageSize"
        (change)="onPageSizeChange($event)">
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
      </select>
      <button
        class="btn-page"
        [disabled]="currentPage === 1"
        (click)="prevPage()">
        &lt; Prev
      </button>
      <button
        class="btn-page"
        [disabled]="currentPage * pageSize >= totalEntries"
        (click)="nextPage()">
        Next &gt;
      </button>
    </div>
  </div>
</div>
